import SolicitacaoReembolsoAtividade from './componentes/SolicitacaoReembolsoAtividade.vue';
import SolicitacaoReembolsoAtividadeLista from './componentes/SolicitacaoReembolsoAtividadeLista.vue';

export default {
  path: '/solicitacao-reembolso-pf-atividade',
  component: SolicitacaoReembolsoAtividade,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoReembolsoAtividadeLista,
      name: 'solicitacao-reembolso-pf-atividade',
    },
    {
      path: ':idCript/atividade',
      name: 'solicitacao-reembolso-pf-atividade.registrar',
      redirect: to => ({ name: 'solicitacao-reembolso-pf-atividade', query: { abrir: to.params.idCript } }),
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-atividade/rotas.js